import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0992c24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AdminUsers" }
const _hoisted_2 = { id: "showusers" }
const _hoisted_3 = { class: "display-2 adminHeadline" }
const _hoisted_4 = { class: "tabHeight" }
const _hoisted_5 = { class: "row align--center justify--start" }
const _hoisted_6 = { class: "md1 flex ml-4" }
const _hoisted_7 = {
  class: "md3 flex",
  style: {"display":"flex"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_9 = { class: "md2 flex" }
const _hoisted_10 = { class: "md2 flex" }
const _hoisted_11 = { class: "row align--center justify--start mt-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md1 ml-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Kolonner:")
], -1))
const _hoisted_13 = {
  class: "flex md10",
  style: {"display":"flex"}
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_16 = {
  class: "va-table va-table--striped usersTable",
  style: {"width":"100%"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Handlinger", -1))
const _hoisted_18 = ["id"]
const _hoisted_19 = ["id"]
const _hoisted_20 = ["id"]
const _hoisted_21 = ["id"]
const _hoisted_22 = ["id"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_25 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_27 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_28 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_30 = { class: "selectPageSize" }
const _hoisted_31 = { class: "layout gutter--xl" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = { class: "center readingSize" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Er du sikker på at du vil slette ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode("?")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Personlige oplysninger")
const _hoisted_40 = { class: "layout gutter--md" }
const _hoisted_41 = { class: "row" }
const _hoisted_42 = { class: "flex md6 userModal" }
const _hoisted_43 = {
  key: 0,
  class: "flex md6 center"
}
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Generer ny adgangskode")
const _hoisted_45 = {
  key: 1,
  class: "flex md6"
}
const _hoisted_46 = { class: "row align--center" }
const _hoisted_47 = { class: "flex md1" }
const _hoisted_48 = { class: "flex md7" }
const _hoisted_49 = { class: "flex md2" }
const _hoisted_50 = { class: "flex md2" }
const _hoisted_51 = { class: "flex md6 userModal" }
const _hoisted_52 = { class: "flex md6 userModal" }
const _hoisted_53 = { class: "flex md6 userModal" }
const _hoisted_54 = { class: "flex md6 userModal" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Brugerstyringsrelaterede oplysninger")
const _hoisted_57 = { class: "layout gutter--md" }
const _hoisted_58 = { class: "row align--center" }
const _hoisted_59 = { class: "flex md6 center userModal" }
const _hoisted_60 = { class: "flex md6 center userModal" }
const _hoisted_61 = { class: "flex md6 center userModal" }
const _hoisted_62 = { class: "flex md6 center userModal" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_64 = { class: "row align--center" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md6 flex userModal" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Felter markeret med * kan ikke ændres")
], -1))
const _hoisted_66 = { class: "md6 flex center userModal" }
const _hoisted_67 = /*#__PURE__*/_createTextVNode("Ekporter bruger")
const _hoisted_68 = /*#__PURE__*/_createTextVNode("Opdater Bruger")
const _hoisted_69 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_70 = { class: "tabHeight" }
const _hoisted_71 = { id: "newusers" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = {
  key: 1,
  class: "form"
}
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { class: "userform-group" }
const _hoisted_76 = { class: "layout gutter--xl" }
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "flex md12" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = {
  key: 0,
  class: "flex md6"
}
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "flex md6" }
const _hoisted_83 = { class: "flex md6" }
const _hoisted_84 = { class: "row" }
const _hoisted_85 = { class: "flex md6" }
const _hoisted_86 = { class: "flex md6" }
const _hoisted_87 = { class: "row" }
const _hoisted_88 = { class: "flex md6" }
const _hoisted_89 = { class: "row justify--center" }
const _hoisted_90 = { class: "flex" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode("Opret bruger")
const _hoisted_92 = { class: "tabHeight" }
const _hoisted_93 = { class: "kategori-liste" }
const _hoisted_94 = { class: "row justify--start align--baseline" }
const _hoisted_95 = {
  class: "flex md4",
  style: {"text-align":"left"}
}
const _hoisted_96 = /*#__PURE__*/_createTextVNode("group")
const _hoisted_97 = { class: "flex md8" }
const _hoisted_98 = { class: "row justify--center" }
const _hoisted_99 = { class: "center" }
const _hoisted_100 = /*#__PURE__*/_createTextVNode("Rediger rettigheder")
const _hoisted_101 = /*#__PURE__*/_createTextVNode("Se rettigheder")
const _hoisted_102 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_103 = { class: "layout gutter--xl" }
const _hoisted_104 = { class: "row" }
const _hoisted_105 = { class: "flex" }
const _hoisted_106 = { class: "center readingSize" }
const _hoisted_107 = /*#__PURE__*/_createTextVNode("Er du sikker på at du vil slette ")
const _hoisted_108 = /*#__PURE__*/_createTextVNode("?")
const _hoisted_109 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_110 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_111 = {
  class: "editusergroupdrawer-r2",
  style: {"display":"block"}
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Brugergruppe-rettigheder", -1))
const _hoisted_113 = { style: {"display":"flex","float":"left","padding":"4px","justify-content":"center"} }
const _hoisted_114 = { style: {"font-weight":"500","margin-right":"4px"} }
const _hoisted_115 = { style: {"display":"flex","float":"left","padding":"4px","justify-content":"center"} }
const _hoisted_116 = /*#__PURE__*/_createTextVNode("Gem rettigheder")
const _hoisted_117 = /*#__PURE__*/_createTextVNode("Gem rettigheder og luk")
const _hoisted_118 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_119 = { class: "tabHeight" }
const _hoisted_120 = { id: "newusergroups" }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = {
  key: 1,
  class: "form mt-4"
}
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { class: "usergroupform-group" }
const _hoisted_125 = { class: "layout gutter--xl" }
const _hoisted_126 = { class: "row justify--center" }
const _hoisted_127 = { class: "md10 flex" }
const _hoisted_128 = { class: "row justify--center" }
const _hoisted_129 = { class: "flex" }
const _hoisted_130 = /*#__PURE__*/_createTextVNode("Opret ny brugergruppe")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_form = _resolveComponent("va-form")!
  const _component_it_icon = _resolveComponent("it-icon")!
  const _component_it_checkbox = _resolveComponent("it-checkbox")!
  const _component_it_button = _resolveComponent("it-button")!
  const _component_it_drawer = _resolveComponent("it-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_va_tabs, {
        class: "adminTabs",
        modelValue: _ctx.tabValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabValue) = $event))
      }, {
        tabs: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Vis og rediger brugere', 'Opret ny bruger', 'Vis og rediger brugergrupper', 'Opret ny brugergruppe'], (title) => {
            return _createVNode(_component_va_tab, {
              name: title,
              key: title
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(title), 1)
              ]),
              _: 2
            }, 1032, ["name"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.columnSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.userSearchInputValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.findUser()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.findUser()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              label: "Brugerstatus",
              modelValue: _ctx.filterStatusStringValue,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterStatusStringValue) = $event)),
              options: _ctx.filterStatusStringOptions,
              bordered: "",
              style: {"width":"75%"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              label: "Brugergruppe",
              modelValue: _ctx.userGroupFilterValue,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userGroupFilterValue) = $event)),
              options: _ctx.userGroupFilterOptions,
              bordered: "",
              searchable: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnDisplays,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.columnDisplays) = $event)),
              "array-value": "name",
              label: "Navn"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnDisplays,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.columnDisplays) = $event)),
              "array-value": "userName",
              label: "Brugernavn"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnDisplays,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.columnDisplays) = $event)),
              "array-value": "email",
              label: "Email"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnDisplays,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.columnDisplays) = $event)),
              "array-value": "telephone",
              label: "Telefon"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnDisplays,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.columnDisplays) = $event)),
              "array-value": "userGroup",
              label: "Brugergruppe"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnDisplays,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.columnDisplays) = $event)),
              "array-value": "lastLogin",
              label: "Sidste login"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnDisplays,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.columnDisplays) = $event)),
              "array-value": "created",
              label: "Oprettet"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createElementVNode("table", _hoisted_16, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.columnSort('navn')))
                    }, "Navn", 512), [
                      [_vShow, _ctx.showColumn('name')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.columnSort('brugernavn')))
                    }, "Brugernavn", 512), [
                      [_vShow, _ctx.showColumn('userName')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.columnSort('email')))
                    }, "Email", 512), [
                      [_vShow, _ctx.showColumn('email')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.columnSort('telefon')))
                    }, "Telefonnummer", 512), [
                      [_vShow, _ctx.showColumn('telephone')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.columnSort('gruppenavn')))
                    }, "Gruppe", 512), [
                      [_vShow, _ctx.showColumn('userGroup')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.columnSort('login')))
                    }, "Sidste login", 512), [
                      [_vShow, _ctx.showColumn('lastLogin')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting center",
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.columnSort('created')))
                    }, "Oprettet", 512), [
                      [_vShow, _ctx.showColumn('created')]
                    ]),
                    _hoisted_17
                  ])
                ]),
                _withDirectives(_createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brugers, (bruger, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: bruger.id
                    }, [
                      _withDirectives(_createElementVNode("td", {
                        id: 'userstable-row' + (index+1)
                      }, _toDisplayString(bruger.firstname) + " " + _toDisplayString(bruger.lastname), 9, _hoisted_18), [
                        [_vShow, _ctx.showColumn('name')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'userstable-row' + (index+1)
                      }, _toDisplayString(bruger.username), 9, _hoisted_19), [
                        [_vShow, _ctx.showColumn('userName')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'userstable-row' + (index+1)
                      }, _toDisplayString(bruger.email), 9, _hoisted_20), [
                        [_vShow, _ctx.showColumn('email')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'userstable-row' + (index+1),
                        class: "center"
                      }, _toDisplayString(bruger.phone), 9, _hoisted_21), [
                        [_vShow, _ctx.showColumn('telephone')]
                      ]),
                      _withDirectives(_createElementVNode("td", null, _toDisplayString(_ctx.getUserGroupFromGroupId(bruger.usrgroup !== null ? bruger.usrgroup.id : 0)), 513), [
                        [_vShow, _ctx.showColumn('userGroup')]
                      ]),
                      _withDirectives(_createElementVNode("td", null, _toDisplayString((bruger.lastActive === null ? 'Aldrig' : bruger.lastActive)), 513), [
                        [_vShow, _ctx.showColumn('lastLogin')]
                      ]),
                      _withDirectives(_createElementVNode("td", { class: "center" }, _toDisplayString(new Date(bruger.created_at).toLocaleDateString('da-DK', {day: '2-digit', month: '2-digit', year: '2-digit'}).replaceAll('.', '/') + ' kl.' + new Date(bruger.created_at).toLocaleTimeString('da-DK', { hour: '2-digit', minute: '2-digit' })), 513), [
                        [_vShow, _ctx.showColumn('created')]
                      ]),
                      _createElementVNode("td", {
                        id: 'userstable-row' + (index+1)
                      }, [
                        _createVNode(_component_va_button_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_button, {
                              class: "btn",
                              color: "info",
                              name: "edituser",
                              onClick: ($event: any) => (_ctx.editUser(bruger.id))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_23
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_va_button, {
                              class: "btn status-width",
                              icon: !bruger.blocked ? 'check_box' : 'check_box_outline_blank',
                              color: !bruger.blocked ? 'success' : 'rgb(255, 172, 10)',
                              name: "blockUser",
                              onClick: ($event: any) => (_ctx.blockUser(bruger.id))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(!bruger.blocked ? 'Aktiv' : 'Inaktiv'), 1)
                              ]),
                              _: 2
                            }, 1032, ["icon", "color", "onClick"]),
                            _createVNode(_component_va_button, {
                              class: "btn",
                              color: "danger",
                              name: "deleteuser",
                              onClick: ($event: any) => (_ctx.deleteUserWarning(bruger.id, bruger.username))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_24
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ], 8, _hoisted_22)
                    ]))
                  }), 128))
                ], 512), [
                  [_vShow, _ctx.columnDisplays.length > 0]
                ])
              ])
            ])),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.jumpToPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.turnToNewPage(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.turnToNewPage(-1)))
          }),
          _hoisted_26,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.currentPage) = $event)),
            type: "number",
            onKeyup: _cache[25] || (_cache[25] = _withKeys(($event: any) => (_ctx.jumpToPage(this.currentPage)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentPage]
          ]),
          (_ctx.totalNumberOfPages === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_27, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_28, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.turnToNewPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.turnToNewPage(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.jumpToPage(this.totalNumberOfPages)))
          }),
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.pageSizeValueString,
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
              options: _ctx.pageSizeOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.warningModal,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.warningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          color: "danger"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-2",
              color: "danger",
              onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.deleteUser(this.deleteUserId), _ctx.$Message.success({ text: 'Brugeren er blevet slettet' })))
            }, {
              default: _withCtx(() => [
                _hoisted_37
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn ml-2",
              color: "secondary",
              onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.warningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_38
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("p", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("strong", null, _toDisplayString(this.deleteUserName), 1),
                    _hoisted_36
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editUserModal,
          "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.editUserModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.updateUser()))
            }, {
              default: _withCtx(() => [
                _hoisted_68
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev anulleret' }), (_ctx.editUserModal = false), _ctx.cancelUserEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_69
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_va_card, {
              color: "#afcfff",
              gradient: "true",
              stripe: "true",
              "stripe-color": "#2f5f4f"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_card_title, null, {
                  default: _withCtx(() => [
                    _hoisted_39
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_card_content, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_va_input, {
                            class: "inputSizing",
                            type: "text",
                            modelValue: _ctx.brugerData.brugerBrugernavn,
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.brugerData.brugerBrugernavn) = $event)),
                            label: "Brugernavn",
                            rules: [(v) => v.length > 1 || 'Brugernavn mangler'],
                            placeholder: "Unikt brugernavn",
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        (!_ctx.newPassword)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              _createVNode(_component_va_button, {
                                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.generateNewPassword())),
                                color: "info",
                                gradient: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_44
                                ]),
                                _: 1
                              })
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                  _createVNode(_component_va_icon, {
                                    class: "refreshBtn",
                                    name: "refresh",
                                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.generateNewPassword()))
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_48, [
                                  _createVNode(_component_va_input, {
                                    class: "inputSizing",
                                    modelValue: _ctx.newPasswordString,
                                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.newPasswordString) = $event)),
                                    type: "text",
                                    label: "Ny adgangskode",
                                    rules: [(v) => (v.length === 0 || v.length >= 8) || 'Adgangskoden skal indeholde både store og små bogstaver, tal og specialtegn'],
                                    placeholder: "********",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                  _createVNode(_component_va_button, {
                                    onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.updatePassword())),
                                    color: "success",
                                    gradient: "",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_va_icon, { name: "task_alt" })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_50, [
                                  _createVNode(_component_va_button, {
                                    onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.cancelNewPassword())),
                                    color: "secondary",
                                    gradient: "",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_va_icon, { name: "clear" })
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ])),
                        _createElementVNode("div", _hoisted_51, [
                          _createVNode(_component_va_input, {
                            class: "inputSizing",
                            type: "text",
                            modelValue: _ctx.brugerData.brugerFornavn,
                            "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.brugerData.brugerFornavn) = $event)),
                            label: "Fornavn",
                            rules: [(v) => v.length > 1 || 'Der mangler et fornavn'],
                            placeholder: "Navn",
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(_component_va_input, {
                            class: "inputSizing",
                            type: "text",
                            modelValue: _ctx.brugerData.brugerEfternavn,
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.brugerData.brugerEfternavn) = $event)),
                            label: "Efternavn",
                            rules: [(v) => v.length > 1 || 'Der mangler et efternavn'],
                            placeholder: "Navn",
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_va_input, {
                            class: "inputSizing",
                            type: "text",
                            modelValue: _ctx.brugerData.brugerTelefon,
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.brugerData.brugerTelefon) = $event)),
                            label: "Telefon-nr.",
                            rules: [(v) => v.trim().length > 7 || 'Telefonnummeret mangler'],
                            placeholder: "Nr. med mindst 8 cifre",
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createVNode(_component_va_input, {
                            class: "inputSizing",
                            type: "email",
                            modelValue: _ctx.brugerData.brugerEmail,
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.brugerData.brugerEmail) = $event)),
                            label: "Email",
                            rules: [(v) => _ctx.checkEmail(v) || 'Der mangler en mailadresse'],
                            placeholder: "mailuser@domain.tld",
                            bordered: ""
                          }, null, 8, ["modelValue", "rules"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_55,
            _createVNode(_component_va_card, {
              color: "#afcfff",
              gradient: "true",
              stripe: "true",
              "stripe-color": "#2f5f4f"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_card_title, null, {
                  default: _withCtx(() => [
                    _hoisted_56
                  ]),
                  _: 1
                }),
                _createVNode(_component_va_card_content, null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("div", _hoisted_59, [
                          _createVNode(_component_va_select, {
                            label: "Brugergruppe",
                            bordered: "",
                            id: "editusermodal-brugegruppe",
                            modelValue: _ctx.brugerData.userGroupNamesValue,
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.brugerData.userGroupNamesValue) = $event)),
                            options: _ctx.userGroupNamesOptions
                          }, null, 8, ["modelValue", "options"])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _createVNode(_component_va_input, {
                            type: "datetime-local",
                            modelValue: _ctx.brugerData.brugerOprettet,
                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.brugerData.brugerOprettet) = $event)),
                            label: "Bruger oprettet *",
                            readonly: "",
                            bordered: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          (_ctx.brugerData.brugerLogin == '1970-01-01T00:00')
                            ? (_openBlock(), _createBlock(_component_va_input, {
                                key: 0,
                                class: "mb-4",
                                type: "text",
                                label: "Sidste login *",
                                placeholder: "Aldrig",
                                readonly: "",
                                bordered: ""
                              }))
                            : (_openBlock(), _createBlock(_component_va_input, {
                                key: 1,
                                type: "datetime-local",
                                modelValue: _ctx.brugerData.brugerLogin,
                                "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.brugerData.brugerLogin) = $event)),
                                label: "Sidste Login *",
                                readonly: "",
                                bordered: ""
                              }, null, 8, ["modelValue"]))
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createVNode(_component_va_input, {
                            type: "datetime-local",
                            modelValue: _ctx.brugerData.brugerUpdate,
                            "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.brugerData.brugerUpdate) = $event)),
                            label: "Sidste opdatering *",
                            placeholder: "Aldrig",
                            readonly: "",
                            bordered: ""
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_63,
            _createElementVNode("div", _hoisted_64, [
              _hoisted_65,
              _createElementVNode("div", _hoisted_66, [
                _createVNode(_component_va_button, {
                  onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.exportUser())),
                  color: "info",
                  gradient: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_67
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger brugere']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_70, [
        _createElementVNode("div", _hoisted_71, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_73, [
                (!_ctx.submitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "newuserform"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("div", _hoisted_77, [
                                _createElementVNode("div", _hoisted_78, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.brugerData.brugerBrugernavn,
                                    "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.brugerData.brugerBrugernavn) = $event)),
                                    type: "text",
                                    label: "Brugernavn",
                                    rules: [(brugerBrugernavn) => _ctx.brugerData.brugerBrugernavn.length > 1 || 'Brugernavn mangler'],
                                    placeholder: "Unikt brugernavn",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_79, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(_ctx.brugerData.brugerPassword.length < 8 ? 'flex md12' : 'flex md6')
                                }, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.brugerData.brugerPassword,
                                    "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.brugerData.brugerPassword) = $event)),
                                    type: "password",
                                    label: "Adgangskode (minimum 8 tegn)",
                                    rules: [(brugerPassword) => _ctx.passwordTest(_ctx.brugerData.brugerPassword) || 'Adgangskoden skal indeholde både store og små bogstaver, tal og specialtegn'],
                                    placeholder: "********",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ], 2),
                                (_ctx.brugerData.brugerPassword.length >= 8)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                                      _createVNode(_component_va_input, {
                                        class: "mb-4 item",
                                        modelValue: _ctx.repeatPassword,
                                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.repeatPassword) = $event)),
                                        type: "password",
                                        label: "Gentag adgangskoden",
                                        rules: [value => value === _ctx.brugerData.brugerPassword || 'Adgangskoderne skal være ens'],
                                        placeholder: "********",
                                        bordered: "",
                                        disabled: _ctx.brugerData.brugerPassword.length < 8,
                                        hidden: _ctx.brugerData.brugerPassword.length < 8
                                      }, null, 8, ["modelValue", "rules", "disabled", "hidden"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_81, [
                                _createElementVNode("div", _hoisted_82, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.brugerData.brugerFornavn,
                                    "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.brugerData.brugerFornavn) = $event)),
                                    type: "text",
                                    label: "Fornavn",
                                    rules: [(brugerFornavn) => _ctx.brugerData.brugerFornavn.length > 1 || 'Der mangler et fornavn'],
                                    placeholder: "Navn",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_83, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.brugerData.brugerEfternavn,
                                    "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.brugerData.brugerEfternavn) = $event)),
                                    type: "text",
                                    label: "Efternavn",
                                    rules: [(brugerEfternavn) => _ctx.brugerData.brugerEfternavn.length > 1 || 'Der mangler et efternavn'],
                                    placeholder: "Navn",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_84, [
                                _createElementVNode("div", _hoisted_85, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.brugerData.brugerTelefon,
                                    "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.brugerData.brugerTelefon) = $event)),
                                    type: "number",
                                    label: "Telefonnummer",
                                    rules: [(brugerTelefon) => _ctx.brugerData.brugerTelefon.trim().length > 7 || 'Telefonnummer mangler'],
                                    placeholder: "Nr. med mindst 8 cifre",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_86, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4 item",
                                    modelValue: _ctx.brugerData.brugerEmail,
                                    "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.brugerData.brugerEmail) = $event)),
                                    type: "email",
                                    label: "Email",
                                    rules: [(v) => _ctx.checkEmail(v) || 'Der mangler en mailadresse'],
                                    placeholder: "mailuser@domain.tld",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_87, [
                                _createElementVNode("div", _hoisted_88, [
                                  _createVNode(_component_va_select, {
                                    label: "Brugergruppe",
                                    bordered: "",
                                    id: "editusermodal-brugegruppe",
                                    modelValue: _ctx.userGroupNamesValue,
                                    "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.userGroupNamesValue) = $event)),
                                    options: _ctx.userGroupNamesOptions
                                  }, null, 8, ["modelValue", "options"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _createElementVNode("div", _hoisted_89, [
                        _createElementVNode("div", _hoisted_90, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "success",
                            size: "large",
                            onClick: _cache[59] || (_cache[59] = ($event: any) => {_ctx.$refs.form.validate(); _ctx.createUser()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_91
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 512), [
        [_vShow, _ctx.tabValue ==='Opret ny bruger']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_92, [
        _createElementVNode("div", _hoisted_93, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usrgroups, (usrgroup, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "layout gutter--xl enkelt-kategori",
              key: usrgroup.id
            }, [
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("div", _hoisted_95, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_va_icon, {
                      class: "material-icons mr-2",
                      color: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_96
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(index+1) + ". " + _toDisplayString(usrgroup.brugergruppe_gruppenavn), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("div", _hoisted_99, [
                      _createVNode(_component_va_button_group, { rounded: false }, {
                        default: _withCtx(() => [
                          (usrgroup.id !== 2)
                            ? (_openBlock(), _createBlock(_component_va_button, {
                                key: 0,
                                color: "primary",
                                class: "btn",
                                onClick: ($event: any) => (_ctx.retrieveUserGroupRights(usrgroup.id))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_100
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : (_openBlock(), _createBlock(_component_va_button, {
                                key: 1,
                                color: "primary",
                                class: "btn",
                                onClick: ($event: any) => (_ctx.retrieveUserGroupRights(usrgroup.id))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_101
                                ]),
                                _: 2
                              }, 1032, ["onClick"])),
                          (usrgroup.id !== 2)
                            ? (_openBlock(), _createBlock(_component_va_button, {
                                key: 2,
                                class: "btn status-width-group",
                                icon: usrgroup.brugergruppe_status ? 'check_box' : 'check_box_outline_blank',
                                color: usrgroup.brugergruppe_status ? 'success' : 'rgb(255, 172, 10)',
                                onClick: ($event: any) => (_ctx.blockUserGroup(usrgroup.id))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(usrgroup.brugergruppe_status ? 'Aktiveret' : 'Blokeret'), 1)
                                ]),
                                _: 2
                              }, 1032, ["icon", "color", "onClick"]))
                            : _createCommentVNode("", true),
                          (usrgroup.id > 6)
                            ? (_openBlock(), _createBlock(_component_va_button, {
                                key: 3,
                                class: "btn",
                                color: "danger",
                                onClick: ($event: any) => (_ctx.deleteUserGroupWarning(usrgroup.brugergruppe_gruppenavn, usrgroup.id, usrgroup.documentId))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_102
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ])
                ])
              ])
            ]))
          }), 128))
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteUserGroupWarningModal,
          "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.deleteUserGroupWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          color: "danger"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-2",
              color: "danger",
              onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.deleteUserGroup(this.deleteUserGroupId, this.deleteUserGroupDocumentId), _ctx.$Message.success({ text: 'Brugergruppen er blevet slettet' })))
            }, {
              default: _withCtx(() => [
                _hoisted_109
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "brn ml-2",
              color: "secondary",
              onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.deleteUserGroupWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_110
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("div", _hoisted_105, [
                  _createElementVNode("p", _hoisted_106, [
                    _hoisted_107,
                    _createElementVNode("strong", null, _toDisplayString(this.deleteUserGroupName), 1),
                    _hoisted_108
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_it_drawer, {
          modelValue: _ctx.editGroupNestedDrawerR2,
          "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.editGroupNestedDrawerR2) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_111, [
              _createVNode(_component_it_icon, {
                box: "",
                name: "group"
              }),
              _hoisted_112
            ]),
            _createVNode(_component_it_divider),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempBrugerGruppe.usrgrouprights, (usrgroupright, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_113, [
                    _createVNode(_component_it_icon, {
                      name: "rule",
                      color: "#3051FF"
                    }),
                    (_ctx.tempBrugerGruppe.id === 2)
                      ? (_openBlock(), _createBlock(_component_it_checkbox, {
                          key: 0,
                          class: "editusergroupdrawer-r2",
                          type: "neutral",
                          label: (index+1)+'. ',
                          modelValue: _ctx.groupRightsCheck[usrgroupright.id],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.groupRightsCheck[usrgroupright.id]) = $event),
                          style: {"margin-right":"4px"},
                          disabled: ""
                        }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]))
                      : (_openBlock(), _createBlock(_component_it_checkbox, {
                          key: 1,
                          class: "editusergroupdrawer-r2",
                          type: "neutral",
                          label: (index+1)+'. ',
                          modelValue: _ctx.groupRightsCheck[usrgroupright.id],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.groupRightsCheck[usrgroupright.id]) = $event),
                          style: {"margin-right":"4px"}
                        }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])),
                    _createElementVNode("p", _hoisted_114, _toDisplayString(usrgroupright.Brugergrupperettighed_navn), 1)
                  ])
                ]),
                _createVNode(_component_it_divider)
              ], 64))
            }), 128)),
            _createElementVNode("div", _hoisted_115, [
              _createVNode(_component_it_button, {
                class: "editusergroupdrawer-r2 btn btn-primary btn-usergrouprightsupdate",
                type: "primary",
                onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.updateUserGroupRights(0))),
                style: {"margin-right":"4px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_116
                ]),
                _: 1
              }),
              _createVNode(_component_it_button, {
                class: "editusergroupdrawer-r2 btn btn-primary btn-usergrouprightsupdate",
                type: "primary",
                onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.updateUserGroupRights(1))),
                style: {"margin-right":"4px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_117
                ]),
                _: 1
              }),
              _createVNode(_component_it_button, {
                class: "editusergroupdrawer-r2 btn btn-primary btn-usergrouprightsupdate",
                type: "primary",
                onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.editGroupNestedDrawerR2 = false)),
                style: {"margin-right":"4px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_118
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger brugergrupper']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_119, [
        _createElementVNode("div", _hoisted_120, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_121, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_122, [
                (!_ctx.submitted2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                      _createElementVNode("div", _hoisted_124, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "newusergroupform"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_125, [
                              _createElementVNode("div", _hoisted_126, [
                                _createElementVNode("div", _hoisted_127, [
                                  _createVNode(_component_va_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.brugerGruppeData.brugerGruppeNavn,
                                    "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.brugerGruppeData.brugerGruppeNavn) = $event)),
                                    type: "text",
                                    placeholder: "Navn",
                                    label: "Brugergruppenavn",
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 512),
                        _createElementVNode("div", _hoisted_128, [
                          _createElementVNode("div", _hoisted_129, [
                            _createVNode(_component_va_button, {
                              class: "btn",
                              color: "success",
                              size: "large",
                              onClick: _cache[68] || (_cache[68] = ($event: any) => (_ctx.createUserGroup()))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_130
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Opret ny brugergruppe']
      ])
    ])
  ]))
}